<lib-prod-form [fields]="fields" [data]="data" (onSubmitEvent)="moveCars($event)"></lib-prod-form>

